<template>
  <div class="container">
    <slot />
  </div>
</template>

<style lang="scss">
@import url(@/assets/styles/element.scss);
.main-body {
  margin: 0px !important;
  width: 100% !important;
}
.sub-body {
  background-color: rgb(154, 21, 23);
}
.container {
  max-width: none;
}
// @media screen and (min-width: 1025px) {
//   .container {
    
//   }
//   .main-body {
//     width: 100% !important;
//   }
// }

// @media screen and (min-width: 1500px) {
//   .main-body {
//     overflow-x: hidden;
//   }
// }
</style>